<template>
  <div class="business-content-main">
    <div class="bread-nav">
      <breadcrumb :canBackHistory="true" :pageTitle="pageTitle"></breadcrumb>
    </div>
    <el-container style="height:100%;width:100%">
      <el-form
        ref="attendanceTimeSetDetail"
        :rules="rules"
        label-position="right"
        label-width="80px"
        style="width:100%"
        :model="attendanceTimeSetDetail"
      >
        <el-form-item prop="SetName" label="名称:" style="width:410px">
          <el-row>
            <el-col :span="12">
              <el-input
                size="small"
                v-model="attendanceTimeSetDetail.SetName"
                placeholder="请填写班次名称"
              ></el-input>
            </el-col>
            <el-col :span="6" style="margin-left:10px;">
              <el-button class="btn-primary" size="small" @click="submitAttendance">保存</el-button>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item label="类型:">
          <el-radio-group
            :disabled="isEdit"
            v-model="attendanceTimeSetDetail.SetType"
            @change="handleTypeSelect"
            size="small"
          >
            <el-radio-button :label="0">按周</el-radio-button>
            <el-radio-button :label="1">按天</el-radio-button>
            <el-radio-button :label="2">按月</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item :label="formName">
          <el-checkbox
            v-if="attendanceTimeSetDetail.SetType==0"
            v-model="attendanceTimeSetDetail.IsAISet"
          >作为智能排班的可选班次</el-checkbox>
          <el-input-number
            size="small"
            style="width:120px"
            v-model="attendanceTimeSetDetail.Period"
            @change="setPeriod"
            :min="1"
            :max="365"
            placeholder="请填写周期"
            v-if="attendanceTimeSetDetail.SetType==1"
          ></el-input-number>
        </el-form-item>
        <el-table
          :resizable="false"
          border
          height="600px"
          style="width:auto;"
          ref="attendanceTimeSetTable"
          :header-cell-style="{background:'#F2F6FC',align:'center'}"
          :data="attendanceTimeSetDetail.ViewList"
          :span-method="cellMerge"
          @row-click="handleRowClick"
        >
          <el-table-column
            :resizable="false"
            align="center"
            type="index"
            :index="indexMethod"
            label="周期/时间"
            width="220px"
          ></el-table-column>
          <el-table-column :resizable="false" header-align="center" label="0" width="60px">
            <template slot-scope="scope">
              <div :key="index" v-for="(item,index) in scope.row.TimeList">
                <el-popover
                  placement="top-start"
                  :title="item.Name"
                  trigger="hover"
                  :content="item.SpanText"
                >
                  <el-tag
                    slot="reference"
                    :style="getTagStyle(item)"
                    size="medium"
                    :color="item.color"
                  >{{getTagItemValue(item)}}</el-tag>
                </el-popover>
              </div>
            </template>
          </el-table-column>
          <el-table-column :resizable="false" header-align="center" label="1" width="60px"></el-table-column>
          <el-table-column :resizable="false" header-align="center" label="2" width="60px"></el-table-column>
          <el-table-column :resizable="false" header-align="center" label="3" width="60px"></el-table-column>
          <el-table-column :resizable="false" header-align="center" label="4" width="60px"></el-table-column>
          <el-table-column :resizable="false" header-align="center" label="5" width="60px"></el-table-column>
          <el-table-column :resizable="false" header-align="center" label="6" width="60px"></el-table-column>
          <el-table-column :resizable="false" header-align="center" label="7" width="60px"></el-table-column>
          <el-table-column :resizable="false" header-align="center" label="8" width="60px"></el-table-column>
          <el-table-column :resizable="false" header-align="center" label="9" width="60px"></el-table-column>
          <el-table-column :resizable="false" header-align="center" label="10" width="60px"></el-table-column>
          <el-table-column :resizable="false" header-align="center" label="11" width="60px"></el-table-column>
          <el-table-column :resizable="false" header-align="center" label="12" width="60px"></el-table-column>
          <el-table-column :resizable="false" header-align="center" label="13" width="60px"></el-table-column>
          <el-table-column :resizable="false" header-align="center" label="14" width="60px"></el-table-column>
          <el-table-column :resizable="false" header-align="center" label="15" width="60px"></el-table-column>
          <el-table-column :resizable="false" header-align="center" label="16" width="60px"></el-table-column>
          <el-table-column :resizable="false" header-align="center" label="17" width="60px"></el-table-column>
          <el-table-column :resizable="false" header-align="center" label="18" width="60px"></el-table-column>
          <el-table-column :resizable="false" header-align="center" label="19" width="60px"></el-table-column>
          <el-table-column :resizable="false" header-align="center" label="20" width="60px"></el-table-column>
          <el-table-column :resizable="false" header-align="center" label="21" width="60px"></el-table-column>
          <el-table-column :resizable="false" header-align="center" label="22" width="60px"></el-table-column>
          <el-table-column :resizable="false" header-align="center" label="23" width="60px"></el-table-column>
          <!-- <el-table-column :resizable="false" header-align="center" label="24" width="60px"></el-table-column> -->
        </el-table>
        <el-dialog width="400px" title="工作时段" :visible.sync="dialogFormVisible" destroy-on-close>
          <el-table
            :reserve-selection="true"
            ref="timeSelectTable"
            :header-cell-style="selectionStyle"
            :data="timeSelectList"
            height="500"
            style="width:100%;"
            @select="handleSelectionChange"
            :sort="{prop:'OnDutyHour'}"
          >
            <el-table-column :reserve-selection="true" type="selection" width="55"></el-table-column>
            <el-table-column prop="Name" label="时段名称" width="100"></el-table-column>
            <el-table-column prop="OnDutyTime" label="上班时间" width="100"></el-table-column>
            <el-table-column prop="OffDutyTime" label="下班时间" width="100"></el-table-column>
          </el-table>
          <el-footer>
            <el-button size="small" @click="dialogFormVisible=false">取消</el-button>
            <el-button
              class="btn-primary"
              type="primary"
              size="small"
              @click="submitTimeSelectList"
            >确定</el-button>
          </el-footer>
          <!-- <el-row type="flex" justify="end" :gutter="20">
            <el-col :span="4">
              <el-button size="small" @click="dialogFormVisible=false">取消</el-button>
            </el-col>
            <el-col :span="4">
             
            </el-col>
          </el-row>-->
        </el-dialog>
      </el-form>
    </el-container>
  </div>
</template>
<script>
let that = this;
import breadcrumb from "@/components/common/breadcrumb";
export default {
  name: "",
  components: {
    breadcrumb
  },
  data() {
    let userMsg = this.$util.getLocalStorage("userMsg");
    return {
      entpId: userMsg.EntpId,
      permission: this.$util.getPermission("WorkTimeSetManage"),
      timeSelectList: [],
      isContain: false,
      attendanceTimeSetDetail: {
        Id: "",
        EntpId:  userMsg.EntpId,
        SetName: "",
        SetType: 0,
        IsAISet: false,
        Period: 3,
        IsDefault: false,
        TimeSetDetails: [],
        ViewList: [] //展示的list

        //----------------------示例---------------------------
        // {
        // "Id":"1511138a-acf0-4edf-abe0-58dd16637900",
        // "EntpId":"39e3b7ac-9744-4be4-9dfc-adbb5c77308f",
        // "SetName":"默认班次",
        // "SetType":0,
        // "IsAISet":false,
        // "Period":1,
        // "IsDefault":true,
        // "TimeSetDetails":[
        //     {
        //         "Sort":1,
        //         "TimeList":[
        //             {
        //                 "DetailId":"869e7f78-118c-460e-b4b1-b9d91c587331",
        //                 "IntervalId":"8ba12211-0425-4df6-be4b-69e980415474",
        //                 "Sort":1,
        //                 "Name":"正常",
        //                 "OnDutyHour":9,
        //                 "OnDutyMinute":30,
        //                 "OffDutyHour":18,
        //                 "OffDutyMinute":0,
        //                 "OnDutyTime":"09:30",
        //                 "OffDutyTime":"18:00"
        //             }
        //         ]
        //     }
        // ]
        // }
      },
      cellMergeList: [],
      week: [
        {
          name: "星期一"
        },
        {
          name: "星期二"
        },
        {
          name: "星期三"
        },
        {
          name: "星期四"
        },
        {
          name: "星期五"
        },
        {
          name: "星期六"
        },
        {
          name: "星期日"
        }
      ],
      hours: [],
      days: [],
      month: [],
      id: "",
      pageTitle: "",
      spanArr: [],
      formName: "智能排班:",
      period: 0,
      dialogFormVisible: false,
      isEdit: true,
      currentRowIndex: -1,
      getTagItemValue(item) {
        let text = "";
        let width =
          item.SpanCount * 60 - item.OnDutyMinute + item.OffDutyMinute;
        let maxLen = width / 10;
        let len = item.SpanText.length;
        if (len > maxLen) {
          let sublen = maxLen - len;
          let temp = item.SpanText;
          text = temp.slice(0, sublen) + "..";
        } else {
          text = item.SpanText;
        }

        return text;
      },
      getTagStyle(item) {
        let style = "position:relative;left:-10px;text-align:center;";
        let width =
          item.SpanCount * 60 - item.OnDutyMinute + item.OffDutyMinute;
        let marginLeft = item.OnDutyHour * 60 + item.OnDutyMinute;
        style += "width:" + width + "px;margin-left:" + marginLeft + "px;";

        return style;
      },
      rules: {
        SetName: [
          { required: true, message: "请输入班次名称", trigger: "blur" }
        ]
      }
    };
  },
  created() {
    this.initView();
    this.pageTitle = "新增班次";
    this.isEdit = false;
    if (this.$route.query.Id) {
      this.isEdit = true;
      this.pageTitle = "编辑班次";
      let id = this.$route.query.Id;
      this.getAttendanceTimeSetDetail(id);
    }
    this.getTimeSelectList();
  },
  mounted() {},
  methods: {
    //TimeList设置表头样式
    selectionStyle(obj) {
      if (obj.columnIndex == 0) obj.column.renderHeader = null;
      return "background: #F2F6FC;";
    },

    initView() {
      this.setHour();
      this.setDays();
      this.setMonth();
      this.setTable(this.attendanceTimeSetDetail.SetType);
    },
    //自定义索引
    indexMethod(index) {
      let indexName = "";

      switch (this.attendanceTimeSetDetail.SetType) {
        case 0:
          if (index < this.week.length) {
            indexName = this.week[index].name;
          }
          break;
        case 1:
          if (index < this.days.length) {
            indexName = this.days[index].name;
          }

          break;
        case 2:
          if (index < this.month.length) {
            indexName = this.month[index].name;
          }
          break;
      }
      return indexName;
    },
    setHour() {
      this.hours = [];
      for (let index = 0; index < 24; index++) {
        this.hours.push(index);
      }
    },
    //初始化按天类型的数组
    setDays() {
      this.days = [];
      for (
        let index = 1;
        index <= this.attendanceTimeSetDetail.Period;
        index++
      ) {
        let day = {
          name: "第" + index + "天"
        };

        this.days.push(day);
      }
    },
    //初始化按月类型的数组
    setMonth() {
      this.month = [];
      for (let index = 1; index <= 31; index++) {
        let day = {
          name: index + "号"
        };
        this.month.push(day);
      }
    },
    //初始化列表
    setTable(type) {
      this.attendanceTimeSetDetail.TimeSetDetails = [];
      this.attendanceTimeSetDetail.ViewList = [];
      let listLength = 0;
      switch (type) {
        case 0:
          listLength = 7;
          break;
        case 1:
          listLength = this.attendanceTimeSetDetail.Period;
          break;
        case 2:
          listLength = 31;
          break;
      }
      for (let index = 0; index < listLength; index++) {
        let data1 = {
          Sort: index + 1,
          TimeList: [
            // {
            //   DetailId: "",
            //   IntervalId: "",
            //   Sort: index,
            //   Name: "",
            //   OnDutyHour: 0,
            //   OnDutyMinute: 0,
            //   OffDutyHour: 0,
            //   OffDutyMinute: 0,
            //   OnDutyTime: "",
            //   OffDutyTime: "",
            //   StartIndex: -1,
            //   SpanCount: -1,
            //   SpanText: ""
            // }
          ]
        };
        let data2 = {
          Sort: index + 1,
          TimeList: [
            // {
            //   DetailId: "",
            //   IntervalId: "",
            //   Sort: index,
            //   Name: "",
            //   OnDutyHour: 0,
            //   OnDutyMinute: 0,
            //   OffDutyHour: 0,
            //   OffDutyMinute: 0,
            //   OnDutyTime: "",
            //   OffDutyTime: "",
            //   StartIndex: -1,
            //   SpanCount: -1,
            //   SpanText: ""
            // }
          ]
        };

        this.attendanceTimeSetDetail.TimeSetDetails.push(data1);
        this.attendanceTimeSetDetail.ViewList.push(data2);
      }
    },
    //选中类型,切换Table
    handleTypeSelect(val) {
      this.setFormName(val);
      if (val == 1) {
        this.setDays();
      }
      this.setTable(val);
    },
    setFormName(val) {
      let name = "";
      switch (val) {
        case 0:
          name = "智能排班:";
          break;
        case 1:
          name = "周期:";
          break;
        case 2:
          name = "";
          break;
      }
      this.formName = name;
    },
    //设置周期
    setPeriod(value) {
      this.setDays();
      this.setTable(1);
    },
    //选中列
    handleRowClick(row, column, event) {
      this.cellMergeList = row.TimeList;
      this.dialogFormVisible = true;
      this.currentRowIndex = row.Sort - 1;
      const list = row.TimeList;
      for (let i = 0; i < list.length; i++) {
        const element = list[i];
        //当没有上一行的时段在里面才添加
        if (element.part != 2) {
          let _row = this.timeSelectList.find(item => {
            return item.Name == element.Name;
          });
          this.$nextTick(() => {
            this.$refs.timeSelectTable.toggleRowSelection(_row, true);
          });
        }
      }
    },

    //table合并列
    //rowIndex 行,column 列(+1)
    cellMerge({ row, column, rowIndex, columnIndex }) {
      //跳过第一列
      if (columnIndex == 0) {
        return;
      }

      if (columnIndex == 1) {
        return {
          rowspan: 1,
          colspan: 24
        };
      }
    },
    //判断时段冲突
    handleSelectionChange(selection, row) {
      // console.info(selection);
      if (selection.length > 0) {
        this.isContain = false;
        const b = selection[selection.length - 1];

        //从第二行起
        if (this.currentRowIndex > 0) {
          //找上一天的时间段(次日)
          let time = this.attendanceTimeSetDetail.ViewList[this.currentRowIndex]
            .TimeList[0];
          if (time && time.OffDutyTime.search("次日") > -1) {
            this.isContain = selection.find(item => {
              let isContain =
                item.OnDutyHour < time.OffDutyHour ||
                (item.OnDutyHour == time.OffDutyHour &&
                  item.OnDutyMinute < time.OffDutyMinute);
              return isContain;
            });

            if (this.isContain) {
              this.$util.warningMsg("所选工作时段和上一天的时段有重叠");
            }
          }
        }

        for (let i = 0; i < selection.length - 1; i++) {
          const a = selection[i];

          //已经全天-24小时
          if (a.OnDutyHour == 0 && a.OffDutyTime.search("次日") > -1) {
            i = selection.length;
            this.isContain = true;
          }
          //结束时间跨日,只需要对比开始时间
          else if (b.OffDutyTime.search("次日") > -1) {
            if (
              b.OnDutyHour >= a.OnDutyHour &&
              b.OffDutyHour < (a.OffDutyHour == 0 ? 24 : a.OffDutyHour)
            ) {
              //b开始时间小于a开始时间,冲突
              this.isContain = true;
            } else if (b.OnDutyTime == a.OffDutyHour) {
              if (b.OffDutyMinute <= a.OffDutyMinute) {
                //b开始小时和a结束小时相等,判断b分钟和a分钟数
                //b和a分钟数相等或者b小于a,冲突
                this.isContain = true;
              }
            }
          } else {
            //不包含次日的时间段比较
            // a.on 包在了 b.on ~ b.off 之间
            if (a.OnDutyHour >= b.OnDutyHour && a.OnDutyHour < b.OffDutyHour) {
              this.isContain = true;
            }
            // b.on 包在了 a.on ~ a.off 之间
            else if (
              a.OnDutyHour <= b.OnDutyHour &&
              a.OffDutyHour > b.OnDutyHour
            ) {
              this.isContain = true;
            }
            // a b 相等
            else if (
              a.OnDutyHour == b.OnDutyHour &&
              a.OffDutyHour == b.OnDutyHour
            ) {
              this.isContain = true;
            } else if (
              //如果小时一样,判断分钟
              a.OnDutyHour == b.OffDutyHour &&
              a.OnDutyMinute < b.OffDutyMinute
            ) {
              this.isContain = true;
            } else if (
              //如果小时一样,判断分钟
              b.OnDutyHour == a.OffDutyHour &&
              b.OnDutyMinute < a.OffDutyMinute
            ) {
              this.isContain = true;
            }
          }

          //只要有一个时间段重复就退出循环
          if (this.isContain == true) {
            i = selection.length;
          }
        }

        if (this.isContain == true) {
          this.$util.warningMsg("所选工作时段有重叠");
        } else {
          this.cellMergeList = selection;
        }
      } else {
        //slelection为空
        this.cellMergeList = [];
      }
    },
    analyzeWorkTimeDate(timesData) {
      let timeData = timesData;
      let spanCount = 0;

      let r = Math.floor(Math.random() * 256);
      let g = Math.floor(Math.random() * 256);
      let b = Math.floor(Math.random() * 256);
      let color = "#" + r.toString(16) + g.toString(16) + b.toString(16);
      timeData.color = color;

      //上班的时长
      if (timeData.OffDutyHour < timeData.OnDutyHour) {
        spanCount = 24 - timeData.OnDutyHour;
      } else {
        spanCount = timeData.OffDutyHour - timeData.OnDutyHour;
      }

      // //合并的列数
      timeData.SpanCount = spanCount;

      //展示的文本
      timeData.SpanText =
        timeData.Name +
        "(" +
        timeData.OnDutyTime +
        "~" +
        timeData.OffDutyTime +
        ")";

      return timeData;
    },
    //刷新列表
    submitTimeSelectList() {
      if (!this.isContain) {
        let currentRow = this.currentRowIndex;
        this.attendanceTimeSetDetail.TimeSetDetails[currentRow].TimeList = [];

        //找本行的次日保留
        let list = this.attendanceTimeSetDetail.ViewList[currentRow].TimeList;
        let temp = null;
        for (let index = 0; index < list.length; index++) {
          const e = list[index];
          if (e.OffDutyTime.search("次日") > -1) {
            if (e.OnDutyHour == 0) {
              temp = e;
            }
          }
        }

        this.attendanceTimeSetDetail.ViewList[currentRow] = {
          Sort: currentRow + 1,
          TimeList: []
        };
        if (temp != null) {
          this.attendanceTimeSetDetail.ViewList[currentRow].TimeList.push(temp);
        }
        //找下一行的次日删了
        if (currentRow + 1 < this.attendanceTimeSetDetail.ViewList.length) {
          list = this.attendanceTimeSetDetail.ViewList[currentRow + 1].TimeList;
          for (let index = 0; index < list.length; index++) {
            const e = list[index];
            if (e.OffDutyTime.search("次日") > -1) {
              if (e.OnDutyHour == 0) {
                this.attendanceTimeSetDetail.ViewList[
                  currentRow + 1
                ].TimeList.shift();
              }
            }
          }
        }

        let tList = [];
        for (let i = 0; i < this.cellMergeList.length; i++) {
          let element = this.cellMergeList[i];
          element = this.analyzeWorkTimeDate(element);
          tList.push({
            DetailId: "",
            IntervalId: element.Id,
            Sort: this.attendanceTimeSetDetail.ViewList[currentRow].Sort,
            Name: element.Name,
            OnDutyHour: element.OnDutyHour,
            OnDutyMinute: element.OnDutyMinute,
            OffDutyHour: element.OffDutyHour,
            OffDutyMinute: element.OffDutyMinute,
            OnDutyTime: element.OnDutyTime,
            OffDutyTime: element.OffDutyTime
          });

          if (element.OffDutyTime.search("次日") > -1) {
            let wtd = {
              DetailId: "",
              IntervalId: element.Id,
              Sort: this.attendanceTimeSetDetail.ViewList[currentRow].Sort,
              Name: element.Name,
              OnDutyHour: element.OnDutyHour,
              OnDutyMinute: element.OnDutyMinute,
              OffDutyHour: 24,
              OffDutyMinute: element.OffDutyMinute,
              OnDutyTime: element.OnDutyTime,
              OffDutyTime: element.OffDutyTime,
              SpanCount: 24 - element.OnDutyHour,
              SpanText: element.SpanText,
              color: element.color,
              part: 1
            };
            this.attendanceTimeSetDetail.ViewList[currentRow].TimeList.push(
              wtd
            );
            if (element.OffDutyHour > 0) {
              let nextWtd = {
                DetailId: "",
                IntervalId: element.Id,
                Sort: this.attendanceTimeSetDetail.ViewList[currentRow + 1]
                  .Sort,
                Name: element.Name,
                OnDutyHour: 0,
                OnDutyMinute: element.OnDutyMinute,
                OffDutyHour: element.OffDutyHour,
                OffDutyMinute: element.OffDutyMinute,
                OnDutyTime: element.OnDutyTime,
                OffDutyTime: element.OffDutyTime,
                SpanCount: element.OffDutyHour,
                SpanText: element.SpanText,
                color: element.color,
                part: 2
              };
              this.attendanceTimeSetDetail.ViewList[
                currentRow + 1
              ].TimeList.push(nextWtd);
            }
          } else {
            this.attendanceTimeSetDetail.ViewList[currentRow].TimeList.push(
              element
            );
          }
        }

        this.attendanceTimeSetDetail.TimeSetDetails[
          currentRow
        ].TimeList = tList;

        this.dialogFormVisible = false;

        // console.info(
        //   this.attendanceTimeSetDetail.TimeSetDetails[currentRow].TimeList
        // );
      } else {
        this.$util.warningMsg("所选工作时段有重叠");
      }
    },
    //获取工作班次详情
    getAttendanceTimeSetDetail(id) {
      let that = this;
      that.$util
        .axiosGet({
          url: "/api/AttendanceSystem/GetAttendanceTimeSetDetail?id=" + id
        })
        .then(res => {
          if (res.data) {
            that.attendanceTimeSetDetail = {
              Id: res.data.Id,
              EntpId: res.data.EntpId,
              SetName: res.data.SetName,
              SetType: res.data.SetType,
              IsAISet: res.data.IsAISet,
              Period: res.data.Period,
              IsDefault: res.data.faIsDefaultlse
            };

            //初始化
            that.setTable(that.attendanceTimeSetDetail.SetType);
            for (
              let k = 0;
              k < that.attendanceTimeSetDetail.TimeSetDetails.length;
              k++
            ) {
              for (let l = 0; l < res.data.TimeSetDetails.length; l++) {
                if (
                  res.data.TimeSetDetails[l].Sort ==
                  that.attendanceTimeSetDetail.TimeSetDetails[k].Sort
                ) {
                  that.attendanceTimeSetDetail.TimeSetDetails[k].TimeList =
                    res.data.TimeSetDetails[l].TimeList;
                }
              }
            }

            let timeSetDetail = that.attendanceTimeSetDetail.TimeSetDetails;
            let viewlist = that.attendanceTimeSetDetail.ViewList;
            for (let i = 0; i < timeSetDetail.length; i++) {
              let element = timeSetDetail[i];
              if (element.Sort == viewlist[i].Sort) {
                for (let j = 0; j < element.TimeList.length; j++) {
                  let detail = element.TimeList[j];
                  detail = that.analyzeWorkTimeDate(detail);
                  if (detail.OffDutyTime.search("次日") > -1) {
                    let wtd = {
                      DetailId: "",
                      IntervalId: detail.Id,
                      Sort: that.attendanceTimeSetDetail.ViewList[i].Sort,
                      Name: detail.Name,
                      OnDutyHour: detail.OnDutyHour,
                      OnDutyMinute: detail.OnDutyMinute,
                      OffDutyHour: 24,
                      OffDutyMinute: detail.OffDutyMinute,
                      OnDutyTime: detail.OnDutyTime,
                      OffDutyTime: detail.OffDutyTime,
                      SpanCount: 24 - detail.OnDutyHour,
                      SpanText: detail.SpanText,
                      color: detail.color,
                      part: 1
                    };
                    that.attendanceTimeSetDetail.ViewList[i].TimeList.push(wtd);
                    if (detail.OffDutyHour > 0) {
                      let nextWtd = {
                        DetailId: "",
                        IntervalId: detail.Id,
                        Sort: that.attendanceTimeSetDetail.ViewList[i + 1].Sort,
                        Name: detail.Name,
                        OnDutyHour: 0,
                        OnDutyMinute: detail.OnDutyMinute,
                        OffDutyHour: detail.OffDutyHour,
                        OffDutyMinute: detail.OffDutyMinute,
                        OnDutyTime: detail.OnDutyTime,
                        OffDutyTime: detail.OffDutyTime,
                        SpanCount: detail.OffDutyHour,
                        SpanText: detail.SpanText,
                        color: detail.color,
                        part: 2
                      };
                      that.attendanceTimeSetDetail.ViewList[
                        i + 1
                      ].TimeList.push(nextWtd);
                    }
                  } else {
                    that.attendanceTimeSetDetail.ViewList[i].TimeList.push(
                      detail
                    );
                  }
                }
              }
            }
          }
        })
        .catch(err => {});
    },
    //获取时段选择列表
    getTimeSelectList() {
      this.$util
        .axiosGet({
          url: "/api/AttendanceSystem/GetTimeSelectList",
          data: {
            entpId: this.entpId
          },
          hideLoading: true
        })
        .then(res => {
          if (res.data) {
            this.timeSelectList = res.data;
          }
        })
        .catch(err => {});
    },
    //编辑工作班次
    editAttendanceTimeSet() {
      let uploadData = {
        Id: this.attendanceTimeSetDetail.Id,
        EntpId: this.attendanceTimeSetDetail.EntpId,
        SetName: this.attendanceTimeSetDetail.SetName,
        SetType: this.attendanceTimeSetDetail.SetType,
        IsAISet: this.attendanceTimeSetDetail.IsAISet,
        Period: this.attendanceTimeSetDetail.Period,
        IsDefault: this.attendanceTimeSetDetail.IsDefault,
        TimeSetDetails: []
      };
      for (
        let i = 0;
        i < this.attendanceTimeSetDetail.TimeSetDetails.length;
        i++
      ) {
        let e1 = this.attendanceTimeSetDetail.TimeSetDetails[i];

        for (let j = 0; j < e1.TimeList.length; j++) {
          let e2 = e1.TimeList[j];
          let times = {
            DetailId: e2.DetailId,
            IntervalId: e2.IntervalId,
            Sort: e2.Sort
          };

          uploadData.TimeSetDetails.push(times);
        }
      }

      this.$util
        .axiosPost({
          url: "/api/AttendanceSystem/EditAttendanceTimeSet",
          data: uploadData
        })
        .then(res => {
          if (res.errcode == 0) {
            this.dialogFormVisible = false;
            this.$util.successMsg("保存成功");
          }
        })
        .catch(err => {});
    },
    submitAttendance() {
      this.$refs["attendanceTimeSetDetail"].validate(valid => {
        if (valid) {
          this.editAttendanceTimeSet();
        } else {
          return false;
        }
      });
    }
  }
};
</script>
<style lang="less" scoped>
.bgColor {
  background-color: black;
}
</style>
